// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// IMPORT PROJECT REFERENCES

import { fetchDevices, searchDevices } from '../State/Actions/DeviceActions';
import { DeviceList } from './DeviceList';
import { LoadingIndicator } from '../Shared/LoadingIndicator/LoadingIndicator';
import { Error } from '../Shared/Error/Error';
import { AddDevice } from './AddDevice';
import { PageToolbar } from './PageToolbar';

// COMPONENT

class DeviceBrowser extends Component {

    constructor(props) {
        super(props);

        this.search = this.search.bind(this);
    }

    componentDidMount() {
        this.props.fetchDevices();
    }

    search(searchText) {
        this.props.searchDevices(searchText);
    }

    render() {
        return (
            <div>
                <AddDevice  />
                <PageToolbar placeholder={"Search devices..."} rightComponent={<button type="button" className="right-detail btn btn-info" data-toggle="modal" data-target="#addDeviceModal">Add Device </button>} search={this.search} />
                { this.props.fetchedDevice && (
                    <div>
                        <DeviceList devices={this.props.filteredDevices} />
                    </div>
                )}
                { <LoadingIndicator busy={this.props.fetchingDevice} />}
                { this.props.failedDevice && <Error message="Failed to fetch devices." /> }
            </div>
        );
    }
}

DeviceBrowser.propTypes = {
    fetchDevices: PropTypes.func.isRequired,
    fetchedDevice: PropTypes.bool.isRequired,
    fetchingDevice: PropTypes.bool.isRequired,
    failedDevice: PropTypes.bool,
    filteredDevices: PropTypes.array.isRequired
};


// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetchingDevice, fetchedDevice, failedDevice, filteredDevices } = state.devicesReducer;
    return { fetchingDevice, fetchedDevice, failedDevice, filteredDevices };
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({ fetchDevices, searchDevices }, dispatch)
);

const hoc = connect(mapStateToProps, mapDispatchToProps)(DeviceBrowser);


// EXPORT COMPONENT

export { hoc as DeviceBrowser };